import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScInputComponent = styled.div`
  max-width: 608px;
  width: 100%;
  margin: auto;

  input,
  input::placeholder {
    font-weight: 700;
  }

  & button {
    min-width: 93px;
  }

  @media (${device.mobileS}) {
    max-width: 100%;
  }
`;
